<template>
  <div class="practical-qs" v-if="questionData">
    <div class="exam-question">
      {{ questionData?.index + 1 }}.（{{ questionData?.questionTypeName }}）{{
        questionData?.questionStem
      }}
      <img class="ques-tip" src="@/assets/images/exam/ques-icon.png" alt="" />
    </div>
    <div class="exam-content">
      <ImageClass
        v-if="questionData.questionType == '1'"
        @change="answer"
        ref="imageClassRef"
      />
      <ImageLabel
        v-else-if="questionData.questionType == '2'"
        @change="answer"
        ref="imageLabelRef"
      />
      <VideoLabel
        v-else-if="questionData.questionType == '3'"
        @change="answer"
        ref="videoLabelRef"
      />
      <AudioLabel
        v-else-if="questionData.questionType == '4'"
        @change="answer"
        ref="audioLabelRef"
      />
      <ChartsBrush
        v-else-if="questionData.questionType == '5'"
        @change="answer"
        ref="chartsBrushRef"
      />
      <BriefAnswer
        v-else-if="questionData.questionType == '6'"
        @change="answer"
        ref="briefAnswerRef"
      />
      <ImageSplit
        v-else-if="questionData.questionType == '7'"
        @change="answer"
        ref="imageSplitRef"
      />
    </div>
  </div>
</template>

<script setup>
import ImageClass from "./components/ImageClass.vue";
import ImageLabel from "./components/ImageLabel.vue";
import VideoLabel from "./components/VideoLabel.vue";
import AudioLabel from "./components/AudioLabel.vue";
import ChartsBrush from "./components/ChartsBrush.vue";
import BriefAnswer from "./components/BriefAnswer.vue";
import ImageSplit from "./components/ImageSplit.vue";
import { defineExpose, ref, defineEmits, getCurrentInstance } from "vue";

const { proxy } = getCurrentInstance();
const emits = defineEmits(["success"]);
const answer = (val) => {
  emits("success", {
    question: questionData.value,
    answer: val,
  });
};
const questionData = ref({});
const open = (question, answer) => {
  questionData.value = question;
  proxy.$nextTick(() => {
    switch (question.questionType) {
      case 1:
        proxy.$refs.imageClassRef.open(question, answer);
        break;
      case 2:
        proxy.$refs.imageLabelRef.open(question, answer);
        break;
      case 3:
        proxy.$refs.videoLabelRef.open(question, answer);
        break;
      case 4:
        proxy.$refs.audioLabelRef.open(question, answer);
        break;
      case 5:
        proxy.$refs.chartsBrushRef.open(question, answer);
        break;
      case 6:
        proxy.$refs.briefAnswerRef.open(question, answer);
        break;
      case 7:
        proxy.$refs.imageSplitRef.open(question, answer);
        break;
    }
  });
};

defineExpose({ open });
</script>

<style scoped lang="less">
.practical-qs {
  display: flex;
  height: 100%;
  flex-direction: column;
  .exam-question {
    margin-bottom: 30px;
    padding: 18px 28px;
    background-color: #f9fafdff;
    border: 1px solid #d5e2fcff;
    border-radius: 10px;
    color: #475775ff;
    font-size: 22px;
    position: relative;
    line-height: 32px;
    .ques-tip {
      width: 14px;
      position: absolute;
      left: 8px;
      top: 26px;
    }
  }
}
</style>
